import { getPrimarySavedPoster } from './primaryCollage';

/**
 * Poster nickname for the user's primary collage (`users.primaryCollageId`), with legacy fallback.
 */
export function getPrimaryCollagePosterNickname(savedPosters, primaryCollageId) {
  if (!Array.isArray(savedPosters)) return '';
  const p = getPrimarySavedPoster(savedPosters, primaryCollageId);
  const raw = p?.posterNickname;
  const trimmed = raw != null ? String(raw).trim() : '';
  return trimmed || '';
}

/** @deprecated Use getPrimaryCollagePosterNickname(savedPosters, primaryCollageId). */
export function getMainPrivateMatchPosterNickname(savedPosters) {
  return getPrimaryCollagePosterNickname(savedPosters, null);
}
